/*eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'remove-qbank-from-cadidate-popup',
  components: {},
  props: ['removeQbankID', 'removeCandidateID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    confirmEvtDeletePopupMethod(){
        this.isSubmitted = true
        this.$store.dispatch('removeQBankFromCandiatesInfoByIdAction', {data:{ck:this.removeCandidateID, qk:this.removeQbankID}}).then((res) => {
          this.closeEvtDeletePopupMethod();
          toast.success("The request has been successfully submitted");  
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
        })
    },
    closeEvtDeletePopupMethod(){
      bus.$emit('removeQbankFromCandidatePopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}


